export default __webpack_public_path__ + "static/media/headline.b6006e11.png";